import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "govuk-footer",
  role: "contentinfo"
}
const _hoisted_2 = { class: "govuk-width-container" }
const _hoisted_3 = { class: "govuk-footer__meta" }
const _hoisted_4 = { class: "govuk-footer__meta-item govuk-footer__meta-item--grow" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "govuk-visually-hidden" }, "Support links", -1)
const _hoisted_6 = { class: "govuk-footer__inline-list" }
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass({ 'govuk-footer__inline-list-item': true })
}
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "govuk-footer__inline-list-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:HMCTSWills@ironmountain.co.uk?subject=Find a Will feedback",
    target: "_blank",
    class: "govuk-footer__link"
  }, "Feedback")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  focusable: "false",
  class: "govuk-footer__licence-logo",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 483.2 195.7",
  height: "17",
  width: "41"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M421.5 142.8V.1l-50.7 32.3v161.1h112.4v-50.7zm-122.3-9.6A47.12 47.12 0 0 1 221 97.8c0-26 21.1-47.1 47.1-47.1 16.7 0 31.4 8.7 39.7 21.8l42.7-27.2A97.63 97.63 0 0 0 268.1 0c-36.5 0-68.3 20.1-85.1 49.7A98 98 0 0 0 97.8 0C43.9 0 0 43.9 0 97.8s43.9 97.8 97.8 97.8c36.5 0 68.3-20.1 85.1-49.7a97.76 97.76 0 0 0 149.6 25.4l19.4 22.2h3v-87.8h-80l24.3 27.5zM97.8 145c-26 0-47.1-21.1-47.1-47.1s21.1-47.1 47.1-47.1 47.2 21 47.2 47S123.8 145 97.8 145"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "govuk-footer__licence-description" }, [
  /*#__PURE__*/_createTextVNode(" All content is available under the "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "govuk-footer__link",
    href: "https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/",
    rel: "license"
  }, "Open Government Licence v3.0"),
  /*#__PURE__*/_createTextVNode(", except where otherwise stated ")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "govuk-footer__meta-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "govuk-footer__link govuk-footer__copyright-logo",
    href: "https://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/uk-government-licensing-framework/crown-copyright/"
  }, "© Crown copyright")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, index) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: index,
                to: { name: item.name },
                custom: ""
              }, {
                default: _withCtx(({ href, navigate }) => [
                  _createElementVNode("li", _hoisted_7, [
                    _createElementVNode("a", {
                      class: "govuk-footer__link",
                      href: href,
                      onClick: navigate
                    }, _toDisplayString(item.text), 9, _hoisted_8)
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128)),
            _hoisted_9
          ]),
          _hoisted_10,
          _hoisted_11
        ]),
        _hoisted_12
      ])
    ])
  ]))
}